import { Icon } from "@fluentui/react";
import {
	Card,
	CardHeader,
	Tooltip,
	Button,
	Text,
} from "@fluentui/react-components";
import { getFileTypeIconProps } from "@fluentui/react-file-type-icons";
import { ArrowDownloadRegular } from "@fluentui/react-icons";
import { AttachmentCardProps } from "./types";
import { useStyle } from "./style";
import { useIntl } from "react-intl";
import { getFileExtensionFromName } from "@/common/helpers";
import { useCallback, useState } from "react";

export const AttachmentCard = (props: AttachmentCardProps) => {
	const { attachment } = props;
	const ext = getFileExtensionFromName(attachment.name);
	const classes = useStyle();
	const intl = useIntl();
	const [wrapperEl, setWrapperEl] = useState<HTMLDivElement | null>(null);
	const wrapperRef = useCallback((node: HTMLDivElement | null) => {
		setWrapperEl(node);
	}, []);

	return (
		<div ref={wrapperRef} style={{ position: "relative" }}>
			<Card
				key={attachment.id ?? attachment.name}
				style={{ width: "12rem", height: "fit-content" }}
				size="small"
				role="listitem"
			>
				<CardHeader
					image={
						<Icon
							{...getFileTypeIconProps({
								extension: ext,
								size: 24,
							})}
						/>
					}
					header={
						<Tooltip
							content={attachment.name}
							relationship="label"
							withArrow
							mountNode={wrapperEl}
						>
							<Text style={{ width: "92px" }} wrap={false} truncate={true}>
								{attachment.name}
							</Text>
						</Tooltip>
					}
					action={
						<Tooltip
							content={intl.formatMessage({
								id: "Interaction.TextContent.DownloadFile",
							})}
							relationship="label"
							withArrow
							mountNode={wrapperEl}
						>
							<Button
								appearance="transparent"
								icon={<ArrowDownloadRegular />}
								href={attachment.url}
								download={attachment.name}
								as="a"
								target="_blank"
								className={classes.downloadAttachmentButton}
							/>
						</Tooltip>
					}
					style={{ paddingLeft: "4px" }}
				/>
			</Card>
		</div>
	);
};
